export enum TarjetaDeCredito {
  AMEX = 'amex',
  DINERS_CLUB = 'diners1',
  DINERS = 'diners2',
  VISA = 'visa',
  MASTERCARD = 'mastercard',
}
